import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import YoutubePlayer2 from './VimeoPlayer2'; // Using the existing player from student portal

/**
 * WebViewPlayer Component
 * 
 * This component is designed to be used in a webview.
 * It reads the 'url' parameter from the URL search params (e.g. ?url=https://example.com/stream.m3u8)
 * and plays it using the existing student portal player (YoutubePlayer2 / VimeoPlayer2 which uses ReactPlayer under the hood).
 * 
 * Alternatively, it can accept a url as a prop.
 */
export default function WebViewPlayer(props: { url?: string }) {
  const [searchParams] = useSearchParams();
  const [videoUrl, setVideoUrl] = useState<string>('');

  useEffect(() => {
    // Priority: Props URL > Query Params URL
    const urlFromParams = searchParams.get('url');
    if (props.url) {
      setVideoUrl(props.url);
    } else if (urlFromParams) {
      setVideoUrl(decodeURIComponent(urlFromParams));
    }
  }, [props.url, searchParams]);

  if (!videoUrl) {
    return (
      <div className="w-full h-screen flex items-center justify-center bg-black text-white">
        <p>No video URL provided. Please pass a ?url= query parameter.</p>
      </div>
    );
  }

  return (
    <div className="w-full h-screen bg-black">
      <YoutubePlayer2 
        url={videoUrl} 
        watchTime={(time: any) => console.log('Watch time:', time)} 
        type="webview"
        role="student"
      />
    </div>
  );
}
